// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-screen {
  display: block;
  position: fixed;
  z-index: 2000;
  background-image: url("https://content.upmchp.com/providerdirectory/assets/icons/loading_spinner.gif");
  background-color: var(--ods-color-white);
  opacity: 0.4;
  background-repeat: no-repeat;
  background-position: center;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-loading-screen/ep-loading-screen.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,sGAAA;EACA,wCAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,MAAA;AACJ","sourcesContent":[".loading-screen {\n    display: block;\n    position: fixed;\n    z-index: 2000;\n    background-image: url(\"https://content.upmchp.com/providerdirectory/assets/icons/loading_spinner.gif\");\n    background-color: var(--ods-color-white);\n    opacity: 0.4;\n    background-repeat: no-repeat;\n    background-position: center;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
